import React from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { path: "/", label: "Hjem" },
  { path: "/program", label: "Program" },
  { path: "/hotell", label: "Informasjon" },
  { path: "/kontakt", label: "Kontakt" },
];

const styles = {
  navbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start", // så logoen ikke drar ned hele høyden
    backgroundColor: "#06111e",
    padding: "0.5rem 1rem",
    color: "#ffffff",
    flexWrap: "wrap", // så det ikke krasjer på mobil
  },
  leftColumn: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    fontSize: "1.4rem",
    fontWeight: "bold",
    marginBottom: "0.25rem",
  },
  linksContainer: {
    display: "flex",
    gap: "1rem",
    flexWrap: "wrap",
  },
  link: {
    color: "#ffffff",
    textDecoration: "none",
    fontWeight: "500",
  },
  active: {
    borderBottom: "2px solid #cedc00",
    paddingBottom: "0.25rem",
  },
  logo: {
    height: "52px", // skaler etter behov
    marginLeft: "1rem",
  },
};

export default function Navbar() {
  const location = useLocation();

  return (
    <nav style={styles.navbar}>
      {/* Venstre kolonne: Tittel + lenker */}
      <div style={styles.leftColumn}>
        <div style={styles.title}>Dekkpartner Gdansk 2025</div>
        <div style={styles.linksContainer}>
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                style={{
                  ...styles.link,
                  ...(isActive ? styles.active : {}),
                }}
              >
                {item.label}
              </Link>
            );
          })}
        </div>
      </div>

      {/* Høyre side: Logo */}
      <img src="/img/DP.png" alt="Dekkpartner logo" style={styles.logo} />
    </nav>
  );
}
